import { Enum } from '../commons/common';
import { SortDirection } from '../order/order';
interface Market {
    id: string;
    symbol: string;
    name: string;
}

interface BankAccount {
    id: number | null;
    cardNumber: string | null;
    iBan: string | null;
    bankName: string | null;
}

export interface Transaction {
    trackingCode: string;
    market: Market;
    amount: number;
    type: Enum;
    state: Enum;
    createdAt: string;
    network: {
        name: string;
        fee: number;
        network: string;
    };
    paymentIdentifier: string;
    voucher: {
        batchNumber: string;
        voucherCode: string;
        voucherActivationCode: string;
    };
    txId: string;
    bankAccount: BankAccount;
    commission: number;
    wallet: {
        walletAddress: string;
        memo: string;
    };
    balanceAfterTransaction: number;
    onPrice: number;
    digitalReceipt: string;
    platform: Enum;
    phoneNumber: string;
    gateWayName: string;
    description: string;
    payoutAmount: number;
    depositIrtType: Enum;
    createdBy: string;
    id: string;
}

export interface TransactionCount {
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export interface TransactionFilterValues {
    startDate?: string;
    endDate?: string;
    sort?: SortDirection;
    market?: string;
    keywords?: string;
    source?: Enum;
    marketType?: Enum;
    type?: Enum;
    state?: Enum;
    platform: Enum;
    depositCurrencyType: Enum;
}

export enum TransactionType {
    Deposit = 1,
    Withdrawal,
}

export interface TransactionDetails {
    id: string;
    trackingCode: string;
    market: Market;
    description: string | null;
    amount: number;
    type: Enum;
    createdBy: string;
    platform: Enum;
    state: Enum;
    createdAt: string; // ISO 8601 format date
    payoutAmount: number;
    level: Enum;
    bankAccount: BankAccount;
    paymentIdentifier: string | null;
    depositIrtType: Enum;
    network: {
        name: string;
        fee: number;
        network: string;
    };
    receptMedia: string | null;
    txId: string | null;
    onPrice: number;
    wallet: {
        walletAddress: string;
        memo: string;
    };
    ip: string;
    voucherCode: string | null;
    voucherActivationCode: string | null;
    commission: number;
    lastModifiedDate: string; // ISO 8601 format date
    lastModifiedBy: string;
    balanceAfterTransaction: number | null;
}
